import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  guser: any; // google-sign-in user
  headers: any;

  constructor() {
    this.guser = sessionStorage.getItem('guser');
    this.guser && (this.guser = JSON.parse(this.guser)); // parse the json back to object

    this.headers = new HttpHeaders();
  }

  ssGuser() {
    this.guser = sessionStorage.getItem('guser');
    this.guser && (this.guser = JSON.parse(this.guser)); // parse the json back to object

    return this.guser;
  }
}
